import { render, staticRenderFns } from "./PostVideoFileUrlCustom.vue?vue&type=template&id=3bb69607&"
import script from "./PostVideoFileUrlCustom.vue?vue&type=script&lang=js&"
export * from "./PostVideoFileUrlCustom.vue?vue&type=script&lang=js&"
import style0 from "./PostVideoFileUrlCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports